  import './TestimonialSection.css';
 import TestimonialCards from './TestimonialCards';

function TestimonialSection({  }) {


 
return (


<section  className="testimonialSection2">

 <h2 className='color-white mb-m'>מה הלקוחות שלנו אומרים</h2> 
<TestimonialCards/>
 
 
<div  style={{ 
  // textAlign:"center",
  }}>
 


</div>


 

 




</section >
);
}

export default TestimonialSection;